<template>
  <FeatureDetailPage feature-key="ai-chat" />
</template>
